<template>
  <div class="text-xs text-gray-800">
    Mehrfachauswahl mit gedrückter <span class="inline-block px-1 leading-5 text-gray-700 bg-white border border-gray-600 rounded-md">{{ keybinding }}</span> Taste.
  </div>
</template>

<script>
export default {
  name: 'MiaMultiSelectHint',

  computed: {
    keybinding() {
      if (/^Mac/i.test(navigator.platform)) {
        return '⌘'
      }

      if (navigator.language !== 'de-DE') {
        return 'Ctrl'
      }

      return 'Strg'
    }
  }
}
</script>
